<template>
	<div class="bigpagebox">
		<div class="header">
			<h3 class="msstitle">聯絡人</h3>
			<span @click="close" class="close">
				<i class="el-icon-close"></i>
			</span>
		</div>

		<div class="messbox">
			<template>
				<div class="imuserlist">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="部門" name="sector">
							<ul class="sector">
								<li v-for="sector in sectors" @click="change_activesector(sector.id)">
									<div class="sectorname">
										<div v-if="activesector == sector.id" class="treeico"><i class="el-icon-caret-bottom"></i></div>
										<div v-else class="treeico"><i class="el-icon-caret-right"></i></div>
										<div>{{sector.name}}</div>
									</div>
									<ul v-show="activesector == sector.id" class="sectortreebox">
										<li @click.stop="" v-for="user in sector.users">
											<div class="userinfo">
												<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+apiurl+user.thumb+')'}"></div>
												<div class="username">{{user.username}}</div>
											</div>
											<div @click.stop="sendim(user.user_id)" class="sendmsg">
												 <el-button>發信息</el-button>
											</div>
										</li>
										
									</ul>
								</li>
								
							</ul>
					
					
						</el-tab-pane>
						<el-tab-pane label="門市" name="store">
							
							<ul class="sector">
								<li v-for="store in stores" @click="change_activestore(store.id)">
									<div class="sectorname">
										<div v-if="activestore == store.id" class="treeico"><i class="el-icon-caret-bottom"></i></div>
										<div v-else class="treeico"><i class="el-icon-caret-right"></i></div>
										<div>{{store.name}}</div>
									</div>
									<ul v-show="activestore == store.id" class="sectortreebox">
										<li @click.stop=""  v-for="user in store.users">
											<div class="userinfo">
												<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+apiurl+user.thumb+')'}"></div>
												<div class="username">{{user.username}}</div>
											</div>
											<div @click.stop="sendim(user.user_id)"  class="sendmsg">
												 <el-button>發消息</el-button>
											</div>
										</li>
										
									</ul>
								</li>
								
							</ul>
							
						</el-tab-pane>
					
					</el-tabs>
				</div>
			</template>
		</div>
		
	</div>
</template>

<script>
	
	export default {
		props: ['refresh'],
		
		data() {
			return {
				
				sectors:{},
				stores:{},
				activeName: 'sector',
				activesector:0,
				activestore:0,
				user_id:0
				
			}
		},
		watch: {
			refresh() {

			}

		},
		methods: {
			
			sendim(to_id){
				this.$emit('sendim', to_id);
			},
			
			change_activesector(sector_id){
				if(this.activesector == sector_id){
					this.activesector = 0;
				}else{
					this.activesector = sector_id;
				}
			},
			change_activestore(store_id){
				
				if(this.activestore == store_id){
					this.activestore = 0;
				}else{
					this.activestore = store_id;
				}
			},
			handleClick(tab, event) {
				if(this.activeName == 'sector'){
					this.getsector();
				}else if(this.activeName == 'store'){
					this.getstore();
				}
			},
			close() {
				this.$emit('closemsgcenter', false);
			},
			
			getsector(){
				this.post('/api/im/sectors', {
					user_id:this.user_id
				}).then((res) => {
					
					this.sectors = res;
				})
			},
			getstore(){
				this.post('/api/im/stores', {
					user_id:this.user_id
				}).then((res) => {
					this.stores = res;
					
				})
			},

		},
		created() {
			this.user_id= parseInt(sessionStorage.getItem('user_id'));
			this.getsector();
		}
	}
</script>

<style scoped>
	.sendmsg{ position: relative; top: -4px;}
	.close{ border-radius: 50%; font-size: 18px; width: 25px; height: 25px; display: flex; justify-content: center; align-items: center; background: #3399ff; color: #fff;}
	.sectortreebox>li{ display: flex; align-items: center; padding-left: 25px; justify-content: space-between; }
	.sectortreebox>li.active{ background: #0000FF;}
	.sectortreebox>li .userinfo{ display: flex; }
	.username{ font-size: 14px; font-weight: bold; line-height: 40px;}
	.userface {
		
		width: 35px;
		height: 35px;
		border-radius: 50%;
		 margin-right: 15px;
	}
	.treeico{ margin-right: 5px; font-size: 18px; color: #626262;}
	.sectorname{ display: flex; align-items: center;}
	.messboxheader {
		padding: 0 15px;
	}

	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
		position: relative;
	}

	.messbox {
		height: calc(100vh - 100px);
		overflow-x: hidden;
		padding: 0 15px;
	}

	.msstitle {
		text-align: center;
	}
</style>
